var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.715,
    height: 17.706,
    viewBox: "0 0 18.715 17.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44469",
    "data-name": "Group 44469",
    transform: "translate(-1600.398 -42.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-more",
    "data-name": "Icon ionic-ios-more",
    transform: "translate(1600.398 42.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24268",
    "data-name": "Path 24268",
    d: "M17.6,15.328a2.283,2.283,0,1,0,2.283,2.283A2.282,2.282,0,0,0,17.6,15.328Z",
    transform: "translate(-8.251 -15.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24269",
    "data-name": "Path 24269",
    d: "M6.783,15.328a2.283,2.283,0,1,0,2.283,2.283,2.282,2.282,0,0,0-2.283-2.283Z",
    transform: "translate(-4.5 -15.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24270",
    "data-name": "Path 24270",
    d: "M28.439,15.328a2.283,2.283,0,1,0,2.283,2.283,2.282,2.282,0,0,0-2.283-2.283Z",
    transform: "translate(-12.007 -15.328)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-more-2",
    "data-name": "Icon ionic-ios-more",
    transform: "translate(1600.398 49.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24268-2",
    "data-name": "Path 24268",
    d: "M17.6,15.328a2.283,2.283,0,1,0,2.283,2.283A2.282,2.282,0,0,0,17.6,15.328Z",
    transform: "translate(-8.251 -15.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24269-2",
    "data-name": "Path 24269",
    d: "M6.783,15.328a2.283,2.283,0,1,0,2.283,2.283,2.282,2.282,0,0,0-2.283-2.283Z",
    transform: "translate(-4.5 -15.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24270-2",
    "data-name": "Path 24270",
    d: "M28.439,15.328a2.283,2.283,0,1,0,2.283,2.283,2.282,2.282,0,0,0-2.283-2.283Z",
    transform: "translate(-12.007 -15.328)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-more-3",
    "data-name": "Icon ionic-ios-more",
    transform: "translate(1600.398 55.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24268-3",
    "data-name": "Path 24268",
    d: "M17.6,15.328a2.283,2.283,0,1,0,2.283,2.283A2.282,2.282,0,0,0,17.6,15.328Z",
    transform: "translate(-8.251 -15.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24269-3",
    "data-name": "Path 24269",
    d: "M6.783,15.328a2.283,2.283,0,1,0,2.283,2.283,2.282,2.282,0,0,0-2.283-2.283Z",
    transform: "translate(-4.5 -15.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24270-3",
    "data-name": "Path 24270",
    d: "M28.439,15.328a2.283,2.283,0,1,0,2.283,2.283,2.282,2.282,0,0,0-2.283-2.283Z",
    transform: "translate(-12.007 -15.328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.cc090d4f29fb5bd2efd3fa152ebcbeec.svg";
export { ForwardRef as ReactComponent };